import type { AxiosResponse } from 'axios'
import { env } from 'constants/env'
import api from 'services/api'
import type { SalesOrderOvResponse } from 'store/SalesOrderContext/types/ovsList'
import type { PendingEDI } from 'store/SalesOrderContext/types/PendingEDI'

import type {
  AddressResponse,
  DraftBodyResponse,
  OrderTracking,
  PaginationQuery,
  RejectAnalysisBody,
  SaleRegion,
  SaleTeam,
} from './types'

type DraftBodyRequest = {
  nr_pedi_rasc: string
}

export const fetchDraftById = async ({
  nr_pedi_rasc,
}: DraftBodyRequest): Promise<DraftBodyResponse> => {
  const response = await api.get<DraftBodyRequest, AxiosResponse<DraftBodyResponse>>(
    `/${env.draftBasePath}/${env.apiVersion}/GetRascunhoById?nr_pedi_rasc=${nr_pedi_rasc}`,
  )
  return response.data
}

type AddressRequest = {
  cd_empr: string
  cd_orgn_vend: string
  cd_canl_dstb: string
  cd_seto_atvd: string
  cd_clie: string
}

export const getClientAddress = async ({
  cd_empr,
  cd_orgn_vend,
  cd_canl_dstb,
  cd_seto_atvd,
  cd_clie,
}: AddressRequest): Promise<AddressResponse[]> => {
  const response = await api.get<AddressRequest, AxiosResponse<AddressResponse[]>>(
    `/${env.clientBasePath}/${env.apiVersion}/ListClienteEntrega?cd_empr=${cd_empr}&cd_orgn_vend=${cd_orgn_vend}&cd_canl_dstb=${cd_canl_dstb}&cd_seto_atvd=${cd_seto_atvd}&cd_clie=${cd_clie}`,
  )
  return response.data
}

export const getSaleRegions = async (channelCode?: string) => {
  const response = await api.get<SaleRegion[]>(`/estrut-comerc/v2/listaRegiao`, {
    params: { codigoCanalDistribuicao: channelCode },
  })
  return response
}

export const getSaleTeam = async () => {
  const response = await api.get<SaleTeam[]>(`/estrut-comerc/v2/ListaEquipe`)
  return response
}

export const getSalesOrderOvs = async (query: PaginationQuery, orderNumber: string) => {
  const { paginas, linhas } = query
  const response = await api.get<SalesOrderOvResponse>(
    `${env.manageOVBasePath}/${orderNumber}/ordens-venda?paginas=${paginas}&linhas=${linhas}`,
  )

  return response.data
}

export const rejectAnalysisRequest = async (body: RejectAnalysisBody) => {
  const response = await api.post(
    `${env.draftBasePath}/${env.apiVersion}/reprovacao-volume-extra`,
    body,
  )
  return response.data
}

export const getPendingEDIs = async (query: PaginationQuery, orderNumber: string) => {
  const { paginas, linhas } = query
  const response = await api.get<PendingEDI[]>(
    `${env.draftBasePath}/${env.apiVersion}/ListTrackingEDI?nr_pedi_rasc=${orderNumber}&paginas=${paginas}&linhas=${linhas}`,
  )

  return response.data
}

export const getOrderTracking = async (query: PaginationQuery, orderNumber: string) => {
  const { paginas, linhas } = query
  const response = await api.get<OrderTracking[]>(
    `${env.draftBasePath}/${env.apiVersion}/ListRascunhoTracking?nr_pedi_rasc=${orderNumber}&nr_pagi=${paginas}&qt_rowcount=${linhas}`,
  )

  return response.data
}
